/**
 * Copy of the search params the next write builds on. nuqs writes through the History API, so
 * while the router pathname is the window's, the address bar is the source; a memory router keeps its own.
 */
export const liveSearchParams = (
  routerParams: URLSearchParams,
  routerPathname: string,
): URLSearchParams =>
  window.location.pathname === routerPathname
    ? new URLSearchParams(window.location.search)
    : new URLSearchParams(routerParams);
